import { useDispatch, usePracticeUsers } from '@witmetrics/data-store';
import { mapToKey } from '@witmetrics/utils/arrays';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import NotesField from '@/components/inputs/NotesField';
import { classes, createComment, styles } from './utils';

export type NewCommentProps = {
  noteId: number;
};

export default function NewComment({ noteId }: NewCommentProps) {
  const dispatch = useDispatch();
  const { onApiError } = useAppState();
  const practiceUsers = usePracticeUsers();
  const [isEditing, toggleEditing] = useToggle();
  const [isSaving, toggleSaving] = useToggle();

  const handleSave = async (message: string) => {
    try {
      toggleSaving(true);
      dispatch.addNoteComments([await createComment(noteId, message)]);
      toggleSaving(false);
      toggleEditing(false);
    } catch (err) {
      toggleSaving(false);
      onApiError(err, 'Error saving comment');
    }
  };

  return isEditing ? (
    <NotesField
      isSaving={isSaving}
      className={classes.field}
      placeholder="New comment..."
      users={mapToKey(practiceUsers, 'user')}
      onSave={handleSave}
      onCancel={() => toggleEditing()}
    />
  ) : (
    <button
      style={styles.placeholder}
      className={classes.placeholder}
      onClick={() => toggleEditing()}>
      Add a comment...
    </button>
  );
}
